import type { TFunction } from 'i18next';
import { isValidElement } from 'react';

import type { ValidatorMessage } from '@/helpers/validators';

export function getErrorTranslation(t: TFunction, value: ValidatorMessage) {
  if (typeof value === 'string') {
    return t(value);
  }

  if (isValidElement(value)) {
    return value;
  }

  const [key, options] = value;

  return t(key, options);
}

export interface FormError {
  field: string;
  message: any;
}

export function replaceErrorField(
  errors: FormError[],
  replace: { [field: string]: string }
) {
  return errors.map((error) => {
    const e = Object.keys(replace).find((k) => k === error.field);

    if (e == null) return error;

    return {
      ...error,
      field: replace[e],
    };
  });
}
